// extracted by mini-css-extract-plugin
export var listItemHeading = "Notifications-module--listItemHeading--5292a";
export var notificationWrapper = "Notifications-module--notificationWrapper--e7ed9";
export var notifications = "Notifications-module--notifications--8deae";
export var notificationsCount = "Notifications-module--notificationsCount--872ce";
export var notificationsIcon = "Notifications-module--notificationsIcon--bf687";
export var notificationsWrapper = "Notifications-module--notificationsWrapper--80169";
export var offset = "Notifications-module--offset--f72a2";